module.exports = "/_next/static/images/41a1aa87efab8f6d347aa8d15514ab7d-pj-man-holding-business-card@0.5x.jpg";